import BlockObserver from './BlockObserver';
import CreditsWindow from './CreditsWindow';
import ScrollSnapping from './ScrollSnapping';

export default class LoadPost {
	constructor() {
		this.ajaxLoadMores      = document.querySelectorAll('.ajax-load-more');
		this.loadMoreButtons    = document.querySelectorAll('.btn--load-more');
		this.loadMoreACF    	= document.querySelectorAll('.btn--load-more-acf');
		this.loadMoreForms      = document.querySelectorAll('.filter-form');

		// Load more functionality, specifically for Block: People
		if(this.loadMoreACF) {
			this.loadMoreACF && this.loadMoreACF.forEach((loadMoreACF) => {
				let loadParent = loadMoreACF.closest('[acfLoadMore]');
				this.loadPostsACF(loadParent.getAttribute('data-page'), loadParent.getAttribute('data-pageid'), loadParent.getAttribute('data-fieldkey'), loadParent)

				loadMoreACF.addEventListener('click', (event) => {
					let loadParent = loadMoreACF.closest('[acfLoadMore]');
					this.loadPostsACF(loadParent.getAttribute('data-page'), loadParent.getAttribute('data-pageid'), loadParent.getAttribute('data-fieldkey'), loadParent)
				})
			})
		}

		// Run the initial load more on page load to get first page of results
		if(this.ajaxLoadMores) {
			this.ajaxLoadMores && this.ajaxLoadMores.forEach((ajaxLoadMore) => {
				if(ajaxLoadMore.hasAttribute('splitloadposts')) {
					let filters 			= ajaxLoadMore.querySelector('.filter-form');
					let articlesInitial		= document.querySelector('[articlesinitial]');
					let articlesAdditional 	= document.querySelector('[articlesadditional]');
					let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
					this.loadPostsSplit('load-more', filters, articlesInitial, articlesAdditional, hideOnFilter);
				} else {
					let loadMoreFilters 			= ajaxLoadMore.querySelector('.filter-form');
					let loadMoreButton 				= ajaxLoadMore.querySelector('.btn--load-more');
					let loadMoreButtonWrapper 		= ajaxLoadMore.querySelector('.load-more-button');
					let loadMoreContainer			= ajaxLoadMore.querySelector('.load-more-container');
					let paginationContainer			= ajaxLoadMore.querySelector('.pagination-container');
					this.loadPosts('load-more', ajaxLoadMore, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
				}
			})
		}

		// If load more button is pressed
		if(this.loadMoreButtons) {
			this.loadMoreButtons && this.loadMoreButtons.forEach((loadButton) => {
				loadButton.addEventListener('click', (event) => {
					if(!loadButton.closest('.ajax-load-more')) {
						let filters 			= document.querySelector('[splitloadposts]').querySelector('.filter-form');
						let articlesInitial		= document.querySelector('[articlesinitial]');
						let articlesAdditional 	= document.querySelector('[articlesadditional]');
						let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
						this.loadPostsSplit('load-more', filters, articlesInitial, articlesAdditional, hideOnFilter);
					} else {
						let ajaxParent 					= loadButton.closest('.ajax-load-more');
						let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
						let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
						let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
						let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
						let paginationContainer			= ajaxParent.querySelector('.pagination-container');
						this.loadPosts('load-more', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
					}
				});
			})
		}

		// If numbered pagination is pressed
		document.body.addEventListener('click', (event) => {
			if(event.target.closest('.numbered-class-here')) {
				event.target.closest('.ajax-load-more').querySelector('form').reset();
				let ajaxParent = event.target.closest('.ajax-load-more');
				if(ajaxParent.hasAttribute('splitloadposts')) {
					let filters 			= ajaxParent.querySelector('.filter-form');
					let articlesInitial		= document.querySelector('[articlesinitial]');
					let articlesAdditional 	= document.querySelector('[articlesadditional]');
					let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
					this.loadPostsSplit('filter-change', filters, articlesInitial, articlesAdditional, hideOnFilter);
				} else {
					let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
					let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
					let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
					let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
					let paginationContainer			= ajaxParent.querySelector('.pagination-container');
					this.loadPosts('filter-change', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
				}
			}

			if(event.target.closest('.pagination-container button')) {
				let paginationTo              	= null;
				let currentPage                   	= event.target.closest('.current-page');
				let clickedPagination               = event.target.closest('.pagination-container button');
				let pageButton      = clickedPagination.getAttribute('data-pagination');

				if(pageButton === 'prev') {
					paginationTo = Number(currentPage.value) - 1;
				} else if(pageButton === 'next') {
					paginationTo = Number(currentPage.value) + 1;
				} else {
					paginationTo = pageButton;
				}

				currentPage.value = paginationTo - 1;

				let ajaxParent = clickedPagination.closest('.ajax-load-more');
				if(ajaxParent.hasAttribute('splitloadposts')) {
					let filters 			= ajaxParent.querySelector('.filter-form');
					let articlesInitial		= document.querySelector('[articlesinitial]');
					let articlesAdditional 	= document.querySelector('[articlesadditional]');
					let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
					this.loadPostsSplit('load-more', filters, articlesInitial, articlesAdditional, hideOnFilter);
				} else {
					let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
					let loadMoreButton 				= ajaxParent.querySelector('.pagination-container');
					let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
					let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
					let paginationContainer			= ajaxParent.querySelector('.pagination-container');
					this.loadPosts('load-more', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
				}
			}
		})

		// Trigger search/filter functionality on change
		if(this.loadMoreForms) {
			this.loadMoreForms && this.loadMoreForms.forEach((loadMoreForm) => {
				this.formFilterOptions 	= loadMoreForm.querySelectorAll('input:not(.search), select');

				// If native input and select
				if(this.formFilterOptions) {
					this.formFilterOptions && this.formFilterOptions.forEach((formFilterOption) => {
						formFilterOption.addEventListener('change', (event) => {
							let ajaxParent = loadMoreForm.closest('.ajax-load-more');
							if(ajaxParent.hasAttribute('splitloadposts')) {
								let filters 			= ajaxParent.querySelector('.filter-form');
								let articlesInitial		= document.querySelector('[articlesinitial]');
								let articlesAdditional 	= document.querySelector('[articlesadditional]');
								let hideOnFilter 		= document.querySelectorAll('[hideonfilter]');
								this.loadPostsSplit('filter-change', filters, articlesInitial, articlesAdditional, hideOnFilter);
							} else {
								let loadMoreFilters 			= ajaxParent.querySelector('.filter-form');
								let loadMoreButton 				= ajaxParent.querySelector('.btn--load-more');
								let loadMoreButtonWrapper 		= ajaxParent.querySelector('.load-more-button');
								let loadMoreContainer			= ajaxParent.querySelector('.load-more-container');
								let paginationContainer			= ajaxParent.querySelector('.pagination-container');
								this.loadPosts('filter-change', ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper);
							}
						})
					})
				}
			})
		}
	}

	loadPosts(loadingType, ajaxParent, loadMoreButton, loadMoreFilters, loadMoreContainer, paginationContainer, loadMoreButtonWrapper) {
		this.ajaxParent     		= ajaxParent;
		this.loadMoreButton     	= loadMoreButton;
		this.loadMoreFilters		= new FormData(loadMoreFilters);
		this.loadMoreContainer  	= loadMoreContainer;
		this.paginationContainer  	= paginationContainer;
		this.loadMoreButtonWrapper	= loadMoreButtonWrapper;

		// Disable load more button to prevent multiple clicks
		if(this.loadMoreButton) {
			this.loadMoreButton.disabled = true;
		}

		if(this.loadMoreContainer && this.loadMoreContainer.getAttribute('data-type')) {
			this.loadMoreFilters.append('loop', this.loadMoreContainer.getAttribute('data-type'));
		}

		if(this.loadMoreContainer && this.loadMoreContainer.getAttribute('data-topafterload')) {
			this.loadMoreFilters.append('topAfterLoad', this.loadMoreContainer.getAttribute('data-topafterload'));
		}

		this.loadMoreFilters.append('buttonType', loadingType);

		// Get results
		fetch('/wp-admin/admin-ajax.php?action=loadPosts', {
			method: 'POST',
			body: this.loadMoreFilters,
		})
		.then(response => response.json())
		.then(data => {
			// Append results to bottom of list
			if(data['results']) {
				// If we are loading more results into the list
				if(data['meta']['showingAll']) {
					loadMoreContainer.innerHTML = '';
					ajaxParent.setAttribute('data-showingall', data['meta']['showingAll']);
					loadMoreFilters.querySelector('.showingAll').value = data['meta']['showingAll'];

					if(data['meta']['showingAll'] === 'true') {
						if(ajaxParent.querySelector('.showing .current')) {
							ajaxParent.querySelector('.showing .current').innerHTML = data['meta']['totalFound'];
						}

						if(ajaxParent.querySelector('.showing .total')) {
							ajaxParent.querySelector('.showing .total').innerHTML = data['meta']['totalFound'];
						}
					}
				}

				if(data['meta']['action'] === 'load-more') {
					if(data['meta']['paginationType'] === 'replace') {
						loadMoreContainer.innerHTML = '';
					}
					data['results'].forEach((result) => {
						loadMoreContainer.insertAdjacentHTML('beforeend', result);
					});
					// If we have changed the filter and loading in fresh data
				} else if(data['meta']['action'] === 'filter-change') {
					if(loadMoreContainer) {
						loadMoreContainer.innerHTML = '';
						data['results'].forEach((result) => {
							loadMoreContainer.insertAdjacentHTML('beforeend', result);
						});
					}
				}
				if(this.loadMoreButtonWrapper) {
					this.loadMoreButtonWrapper.style.display = 'flex';
				}
			} else {
				if(loadMoreContainer) {
					loadMoreContainer.innerHTML = '';
					let notFoundMessage = '<div class="no-results__wrapper c2 c4-l cs2-t cs5-l">'+data['noResultsMessage']+'<button class="btn-alt" data-resetfilters>Clear all filters</button></div>';
					loadMoreContainer.insertAdjacentHTML('beforeend', notFoundMessage);
					this.loadMoreButtonWrapper.style.display = 'none';
				}
			}

			// If pagination is being passed through
			if(data['pagination']) {
				paginationContainer.innerHTML = '';
				paginationContainer.insertAdjacentHTML('beforeend', data['pagination']);
			}

			// Update form data with new current page
			loadMoreFilters.querySelector('.current-page').value = data['meta']['currentPage'];

			// On success, update the load more button data attributes ready for next time around
			if(loadMoreButton) {
				if(!data['meta']['showingAll'] || data['meta']['showingAll'] === 'false') {
					loadMoreButton.disabled = data['meta']['totalFound'] <= data['meta']['currentPage'] * data['meta']['perPage'];
				} else {
					loadMoreButton.disabled = false;
				}
			}

			if(!data['meta']['showingAll'] || data['meta']['showingAll'] === 'false') {
				if(ajaxParent.querySelector('.showing .current')) {
					let currentlyShowing = 0;
					if(data['meta']['currentPage'] * data['meta']['perPage'] > data['meta']['totalFound']) {
						currentlyShowing = data['meta']['totalFound'];
					} else {
						currentlyShowing = data['meta']['currentPage'] * data['meta']['perPage'];
					}
					ajaxParent.querySelector('.showing .current').innerHTML = currentlyShowing;
				}

				if(ajaxParent.querySelector('.showing .total')) {
					ajaxParent.querySelector('.showing .total').innerHTML = data['meta']['totalFound'];
				}
			}

			if(data['meta']['topAfterLoad'] === 'true') {
				this.loadMoreContainer.scrollIntoView();
			}

			// if we have a credits window, re-init the tiles
			if(window.app.creditsWindow){
				window.app.creditsWindow.destroy()
				new CreditsWindow()
			}

			// Reinitialize block observers and scroll snapping
			if (window.app.blockObserver) {
				if (typeof window.app.blockObserver.unmount === 'function') {
					window.app.blockObserver.unmount();
				} else {
					console.warn('BlockObserver unmount method not found');
				}
			}

			// Create new BlockObserver instance
			window.app.blockObserver = new BlockObserver(document.querySelectorAll('[data-watch="true"]'));

			// Reinitialize scroll snapping
			if (document.querySelector('[data-component="scrollSnapping"]')) {
				
				// More defensive cleanup
				if (window.app.scrollSnappings && Array.isArray(window.app.scrollSnappings)) {
					window.app.scrollSnappings.forEach(instance => {
						if (instance && typeof instance.destroy === 'function') {
							instance.destroy();
						}
					});
				}

				// Create new instances
				window.app.scrollSnappings = Array.from(
					document.querySelectorAll('[data-component="scrollSnapping"]')
				).map(el => new ScrollSnapping(el));
				
			}

			return data;
		})
	}

	loadPostsSplit(loadingType, filters, articlesInitial, articlesAdditional, hideOnFilter) {
		let formData = new FormData(filters);

		// Disable load more button to prevent multiple clicks
		if(articlesAdditional.querySelector('.btn--load-more')) {
			articlesAdditional.querySelector('.btn--load-more').disabled = true;
		}

		formData.append('buttonType', loadingType);
		formData.append('splitLoad', true);

		fetch('/wp-admin/admin-ajax.php?action=loadPosts', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			// Append results to bottom of list
			if(data['results']) {
				if(data['meta']['action'] === 'load-more') {
					if(data['results']['columnone']) {
						articlesInitial.querySelector('[columnone]').insertAdjacentHTML('beforeend', data['results']['columnone']);
					}

					if(data['results']['columntwo']) {
						data['results']['columntwo'].forEach((result) => {
							articlesInitial.querySelector('[columntwo]').insertAdjacentHTML('beforeend', '<div class="c2 c12-l">'+result+'</div>');
						});
					}

					if(data['results']['columnthree']) {
						data['results']['columnthree'].forEach((result) => {
							articlesInitial.querySelector('[columnthree]').insertAdjacentHTML('beforeend', '<div class="c2 c12-l">'+result+'</div>');
						});
					}

					if(data['results']['additional'].length) {
						articlesAdditional.style.display = 'grid';
						data['results']['additional'].forEach((result) => {
							articlesAdditional.querySelector('[posts]').insertAdjacentHTML('beforeend', result);
						});
					} else {
						articlesAdditional.style.display = 'none';
					}
				} else if(data['meta']['action'] === 'filter-change') {
					articlesInitial.querySelector('[columnone]').innerHTML = '';
					articlesInitial.querySelector('[columntwo]').innerHTML = '';
					articlesInitial.querySelector('[columnthree]').innerHTML = '';
					articlesAdditional.querySelector('[posts]').innerHTML = '';

					document.querySelectorAll('[hideonfilter]').forEach((toHide) => {
						toHide.style.display = 'none';
					})

					if(data['results']['columnone']) {
						articlesInitial.querySelector('[columnone]').insertAdjacentHTML('beforeend', data['results']['columnone']);
					}

					if(data['results']['columntwo']) {
						data['results']['columntwo'].forEach((result) => {
							articlesInitial.querySelector('[columntwo]').insertAdjacentHTML('beforeend', '<div class="c2 c12-l">'+result+'</div>');
						});
					}

					if(data['results']['columnthree']) {
						data['results']['columnthree'].forEach((result) => {
							articlesInitial.querySelector('[columnthree]').insertAdjacentHTML('beforeend', '<div class="c2 c12-l">'+result+'</div>');
						});
					}

					if(data['results']['additional'].length) {
						articlesAdditional.style.display = 'grid';
						data['results']['additional'].forEach((result) => {
							articlesAdditional.querySelector('[posts]').insertAdjacentHTML('beforeend', result);
						});
					} else {
						articlesAdditional.style.display = 'none';
					}
				}
				articlesInitial.querySelector('[columnone]').classList.remove('cs4-l');
			} else {
				articlesInitial.querySelector('[columnone]').innerHTML = '';
				articlesInitial.querySelector('[columntwo]').innerHTML = '';
				articlesInitial.querySelector('[columnthree]').innerHTML = '';
				articlesAdditional.querySelector('[posts]').innerHTML = '';
				articlesAdditional.style.display = 'none';
				let notFoundMessage = '<div class="no-results__wrapper c2">'+data['noResultsMessage']+'<button class="btn-alt" data-resetfilters>Clear all filters</button></div>';
				articlesInitial.querySelector('[columnone]').classList.add('cs4-l');
				articlesInitial.querySelector('[columnone]').insertAdjacentHTML('beforeend', notFoundMessage);

				document.querySelectorAll('[hideonfilter]').forEach((toHide) => {
					toHide.style.display = 'block';
				})
			}

			// Update form data with new current page
			filters.querySelector('.current-page').value = data['meta']['currentPage'];

			// On success, update the load more button data attributes ready for next time around
			if(articlesAdditional.querySelector('.btn--load-more')) {
				articlesAdditional.querySelector('.btn--load-more').disabled = data['meta']['totalFound'] <= data['meta']['currentPage'] * data['meta']['perPage'];
			} else {
				articlesAdditional.querySelector('.btn--load-more').disabled = false;
			}

			if(document.querySelector('[articlesadditional]').querySelector('.showing .current')) {
				let currentlyShowing = 0;
				if(data['meta']['currentPage'] * data['meta']['perPage'] > data['meta']['totalFound']) {
					currentlyShowing = data['meta']['totalFound'];
				} else {
					currentlyShowing = data['meta']['currentPage'] * data['meta']['perPage'];
				}
				document.querySelector('[articlesadditional]').querySelector('.showing .current').innerHTML = currentlyShowing;
			}

			if(document.querySelector('[articlesadditional]').querySelector('.showing .total')) {
				document.querySelector('[articlesadditional]').querySelector('.showing .total').innerHTML = data['meta']['totalFound'];
			}

			window.app.blockObserver.unmount()
			new BlockObserver(document.querySelectorAll('[data-watch="true"]'))

			return data;
		})
	}




	// Load more functionality, specifically for Block: People
	loadPostsACF(page, pageID, fieldKey, loadParent) {
		let formData = new FormData();

		formData.append('page', page);
		formData.append('pageID', pageID);
		formData.append('fieldKey', fieldKey);

		if(window.innerWidth < 768) {
			formData.append('perPage', 4);
		} else if (window.innerWidth >= 768 && window.innerWidth < 1240) {
			formData.append('perPage', 6);
		} else if (window.innerWidth >= 1240) {
			formData.append('perPage', 12);
		}

		fetch('/wp-admin/admin-ajax.php?action=loadMoreACF', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			if(data['results']) {
				data['results'].forEach((result) => {
					loadParent.querySelector('[loadmoregrid]').insertAdjacentHTML('beforeend', result);
				});
			} else {
				loadParent.querySelector('[loadmoregrid]').innerHTML = '';
				loadParent.querySelector('[loadmoregrid]').insertAdjacentHTML('beforeend', data['meta']['noResultsMessage']);
			}

			loadParent.dataset.page = data['meta']['currentPage'];

			// On success, update the load more button data attributes ready for next time around
			loadParent.querySelector('.btn--load-more-acf').disabled = data['meta']['totalFound'] <= data['meta']['currentPage'] * data['meta']['perPage'];

			if(loadParent.querySelector('.showing .current')) {
				let currentlyShowing = 0;
				if(data['meta']['currentPage'] * data['meta']['perPage'] >= data['meta']['totalFound']) {
					loadParent.querySelector('.load-more-button').style.display = 'none';
					currentlyShowing = data['meta']['totalFound'];
				} else {
					loadParent.querySelector('.load-more-button').style.display = 'flex';
					currentlyShowing = data['meta']['currentPage'] * data['meta']['perPage'];
				}
				loadParent.querySelector('.showing .current').innerHTML = currentlyShowing;
			}

			if(loadParent.querySelector('.showing .total')) {
				loadParent.querySelector('.showing .total').innerHTML = data['meta']['totalFound'];
			}

			window.app.blockObserver.unmount()
			new BlockObserver(document.querySelectorAll('[data-watch="true"]'))

			return data;
		})
	}
}